import React, { useEffect, useMemo, useState } from 'react';
import { Card, CardBody, Container, Input, Button, Label, Row, Col, Form, FormGroup } from 'reactstrap';
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import DatePicker from 'react-datepicker';
import { getActiveUserListAPIURL, getUserWiseDurationReportAPIURL } from 'BaseComponentAPI/UserWiseDurationReportAPI';
import { getUserListForCallAvailabilityAPIURL } from 'BaseComponentAPI/CallAvailability';
import axios from 'axios';
import { useFormik } from 'formik';
import TableContainer from 'components/Common/TableContainer';
import * as Yup from 'yup';
import Select from 'react-select';
import moment from 'moment';
import Spinners from 'components/Common/Spinner';
import PopupWindow from 'components/Common/PopupWindow';
import Loader from 'components/Common/Loader';
import * as XLSX from 'xlsx';  // Import the xlsx library
import { checkPermissions } from 'components/Common/ChkPermissions';
import CantAccessPage from 'components/Common/CantAccessPage';
import { getUsersDailyCallingJourneyReportAPIURL } from 'BaseComponentAPI/UsersDailyCallingJourneyAPI';


const UsersDailyCallingJourneyReport = () => {

    const authUser = useSelector(state => state.Login);
    document.title = "Cockpit";

    const storedPermissions = JSON.parse(localStorage.getItem('permissions')) || {};
    const { canRead, canCreate, canChange } = checkPermissions(storedPermissions);

    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');  // Set the message from passed state
    const [popupType, setPopupType] = useState('');  // Set the type from passed state

    const openPopup = (message, type) => {
        setPopupMessage(message);
        setPopupType(type);
        setIsPopupVisible(true);
    };

    const closePopup = () => {
        setIsPopupVisible(false);
    };

    const columns = useMemo(
        () => [
            {
                header: "Call Time",
                accessorKey: "callTime",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Call Type",
                accessorKey: "callType",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Prev. Header",
                accessorKey: "previousHeader",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Customer Mobile",
                accessorKey: "customerMobile",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Connected / Not Connected",
                accessorKey: "connectedStatus",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Action Time",
                accessorKey: "connectedStatusTime",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Disposition Time",
                accessorKey: "dispositionTime",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Disposition",
                accessorKey: "callDisposition",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Remark Template",
                accessorKey: "remarkTemplate",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Remark Text by User",
                accessorKey: "remarkByUser",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Time Duration",
                accessorKey: "callTimeDuration",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Time difference",
                accessorKey: "timeDifference",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Followup Cnt",
                accessorKey: "followUpCnt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Foll. Up / WO Date",
                accessorKey: "followUpOrWODate",
                enableColumnFilter: false,
                enableSorting: true,
            },
        ],
        []
    );



    const [data, setData] = useState([]);
    const [submittedCallType, setSubmittedCallType] = useState("");
    const [pageNo, setPageNo] = useState(1);  // Track the current page number
    const [pageSize, setPageSize] = useState(10);  // Track page size
    const [totalPages, setTotalPages] = useState('');
    const [totalItems, setTotalItems] = useState('');
    const [nextPage, setNextPage] = useState('');
    const [previousPage, setPreviousPage] = useState('');
    const [currentPage, setCurrentPage] = useState('');
    const customePageSize = [10, 20, 30, 40, 50]

    const [employeeData, setEmployeeData] = useState([]);
    const [employeeId, setEmployeeId] = useState('');
    const [date, setDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [loaderOption, setLoaderOption] = useState(false);
    const [disabelSaveBtn, setDisableSaveBtn] = useState(false);

    // Convert employees array to the format that react-select needs
    const employeeOptions = employeeData.map(emp => ({
        value: emp.userUUID,
        label: emp.userName
    }))

    // Handle the change for the employee ID
    const handleEmployeeIdChange = (e) => {
        setEmployeeId(e.target.value);
    }

    // Handle date change (for both fromDate and toDate)
    const handleDateChange = (date, field) => {
        setData([]);
        formik.setFieldValue(field, date);
    };

    useEffect(() => {
        getData();
    }, [authUser]);


    const getData = async () => {
        setLoaderOption(true);
        if (authUser.headers && Object.keys(authUser.headers).length > 0) {


            try {
                const response = await axios.get(
                    `${getActiveUserListAPIURL}?userUUID=${authUser.headers.userUUID}&isPagination=0&pageNo=0&perPageRec=0`,
                    {
                        headers: { ...authUser.headers },
                        'Authorization': `Bearer ${authUser.headers.access_token}`
                    }
                );

                if (response.data.responseMsg === "Success") {
                    setEmployeeData(response.data.data.items);
                    setTotalPages(response.data.data.totalPages)
                    setTotalItems(response.data.data.totalItems);
                    setNextPage(response.data.data.nextPage);
                    setPreviousPage(response.data.data.previousPage);
                    setCurrentPage(response.data.data.currentPage);
                    setLoaderOption(false);
                }
                else {
                    console.error('API Response Error:', response.data.responseMsg);
                    setLoaderOption(false);
                    openPopup(response.data.responseMsg, 'error')
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                setLoaderOption(false);
                openPopup('Something went wrong!', 'error')
            }
            // finally {
            //     setLoaderOption(false);
            // }
        }
    };

    const handlePageChange = async (newPageNo, newPageSize) => {
        if (data.length != 0) {
            if (authUser.headers && Object.keys(authUser.headers).length > 0) {
                // console.log(`API URL: ${getUsersDailyCallingJourneyReportAPIURL}?employeeUUID=${values.employeeId}&journeyDate=${moment(values.date).format("DD/MM/YYYY")}&isPagination=1&pageNo=${pageNo}&perPageRec=${pageSize}}`);

                try {
                    const response = await axios.get(
                        `${getUsersDailyCallingJourneyReportAPIURL}?employeeUUID=${formik.values.employeeId}&journeyDate=${moment(formik.values.date).format("DD/MM/YYYY")}&isPagination=1&pageNo=${newPageNo}&perPageRec=${newPageSize}`,
                        {
                            headers: { ...authUser.headers },
                            'Authorization': `Bearer ${authUser.headers.access_token}`
                        }
                    );

                    if (response.data.responseMsg === "Records not found") {
                        setLoaderOption(false);
                        setDisableSaveBtn(false);
                        openPopup('Records Not Found.', 'error')
                    }
                    else if (response.data.responseMsg === "Success") {
                        setData(response.data.data.items);
                        setTotalPages(response.data.data.totalPages)
                        setTotalItems(response.data.data.totalItems);
                        setNextPage(response.data.data.nextPage);
                        setPreviousPage(response.data.data.previousPage);
                        setCurrentPage(response.data.data.currentPage);
                        setLoaderOption(false);
                        setDisableSaveBtn(false);
                    }
                    else {
                        console.error('API Response Error:', response.data.responseMsg);
                        setLoaderOption(false);
                        setDisableSaveBtn(false);
                        openPopup(response.data.responseMsg, 'error')
                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                    setLoaderOption(false);
                    setDisableSaveBtn(false);
                    openPopup("Requested Data Not Found / 404", 'warn')
                }
                //  finally {
                //     setLoaderOption(false);
                // }
            }
        }
    };

    const formik = useFormik({
        initialValues: {
            employeeId: '',  // Employee selection field
            date: new Date(),
        },
        validationSchema: Yup.object({
            employeeId: Yup.string()
                .required('Employee is required'),  // Employee ID is required
            date: Yup.date()
                .required('From Date is required'),
        }),

        onSubmit: async (values) => {
            setLoaderOption(true);
            setDisableSaveBtn(true);
            setData([]);
            setTotalPages('');
            setTotalItems('');
            setNextPage('');
            setPreviousPage('');
            setCurrentPage('');
            // console.log(values)
            if (authUser.headers && Object.keys(authUser.headers).length > 0) {
                // console.log(`API URL: ${getUsersDailyCallingJourneyReportAPIURL}?employeeUUID=${values.employeeId}&journeyDate=${moment(values.date).format("DD/MM/YYYY")}&pageNo=${pageNo}&perPageRec=${pageSize}`);

                try {
                    const response = await axios.get(
                        `${getUsersDailyCallingJourneyReportAPIURL}?employeeUUID=${values.employeeId}&journeyDate=${moment(values.date).format("DD/MM/YYYY")}&isPagination=1&pageNo=${pageNo}&perPageRec=${pageSize}`,
                        {
                            headers: { ...authUser.headers },
                            'Authorization': `Bearer ${authUser.headers.access_token}`
                        }
                    );

                    if (response.data.responseMsg === "Records not found") {
                        setLoaderOption(false);
                        setDisableSaveBtn(false);
                        openPopup('Records Not Found.', 'error')
                    }
                    else if (response.data.responseMsg === "Success") {
                        setData(response.data.data.items);
                        setTotalPages(response.data.data.totalPages)
                        setTotalItems(response.data.data.totalItems);
                        setNextPage(response.data.data.nextPage);
                        setPreviousPage(response.data.data.previousPage);
                        setCurrentPage(response.data.data.currentPage);
                        setLoaderOption(false);
                        setDisableSaveBtn(false);
                    }
                    else {
                        console.error('API Response Error:', response.data.responseMsg);
                        setLoaderOption(false);
                        setDisableSaveBtn(false);
                        openPopup(response.data.responseMsg, 'error')
                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                    setLoaderOption(false);
                    setDisableSaveBtn(false);
                    openPopup("Requested Data Not Found / 404", 'warn')
                }
                //  finally {
                //     setLoaderOption(false);
                // }
            }

        },
    });


    const handleEmployeeChange = (selectedOption) => {
        setData([]);
        formik.setFieldValue("date", new Date());
        const selectedEmployeeId = selectedOption ? selectedOption.value : '';
        formik.setFieldValue('employeeId', selectedEmployeeId);  // Set employeeId in formik state
    };

    const exportToExcel = async () => {
        setLoaderOption(true);
        if (authUser.headers && Object.keys(authUser.headers).length > 0) {
            try {
                const response = await axios.get(
                    `${getUsersDailyCallingJourneyReportAPIURL}?employeeUUID=${formik.values.employeeId}&journeyDate=${moment(formik.values.date).format("DD/MM/YYYY")}&isPagination=0&pageNo=0&perPageRec=0`,
                    {
                        headers: { ...authUser.headers },
                        'Authorization': `Bearer ${authUser.headers.access_token}`
                    }
                );

                if (response.data.responseMsg === "Records not found") {
                    setLoaderOption(false);
                    openPopup("Records Not Found.", "error");
                } else if (response.data.responseMsg === "Success") {
                    const rawData = response.data.data.items; // API response data

                    if (!Array.isArray(rawData) || rawData.length === 0) {
                        setLoaderOption(false);
                        openPopup("No data available to export.", "error");
                        return;
                    }

                    // Convert JSON data to a worksheet
                    const ws = XLSX.utils.json_to_sheet(rawData);

                    // Create a new workbook and append the worksheet
                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "User Wise Duration Report");

                    // Generate a timestamped filename
                    const currentDate = new Date().toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })
                        .replace(",", "")
                        .replace(/\//g, "-")
                        .replace(/:/g, "-")
                        .split(" ")
                        .join("_");

                    const empName = employeeOptions.find(option => option.value === formik.values.employeeId);
                    const fileName = `${empName?.label || "Report"}_${currentDate}.xlsx`;

                    // Save the Excel file
                    XLSX.writeFile(wb, fileName);

                    setLoaderOption(false);
                } else {
                    console.error("API Response Error:", response.data.responseMsg);
                    setLoaderOption(false);
                    openPopup(response.data.responseMsg, "error");
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                setLoaderOption(false);
                openPopup(error.message, "error");
            }
        }
    };


    if (!canRead) {
        return (
            <>
                <React.Fragment>
                    <div className="page-content">
                        <Container fluid>
                            <Breadcrumbs title="Users" breadcrumbItem="Users Daily Calling Journey" />
                            <CantAccessPage />
                        </Container>
                    </div>
                </React.Fragment>
            </>
        )
    }
    else {
        if (loaderOption == true) {
            return (
                <>
                    <Loader />
                </>
            )
        }
        else {
            return (
                <React.Fragment>
                    <div className="page-content">
                        <Container fluid>
                            <Breadcrumbs title="Users" breadcrumbItem="Users Daily Calling Journey" />
                            <Card>
                                <CardBody className="border-bottom">
                                    <div style={{ padding: '20px' }}>

                                        <Form onSubmit={formik.handleSubmit}>
                                            <Row>
                                                {/* Employee Select */}
                                                <Col md="4">
                                                    <FormGroup>
                                                        <Label for="employeeId">User Name</Label>
                                                        <Select
                                                            id="employeeId"
                                                            name="employeeId"
                                                            className="form-control-md"
                                                            options={employeeOptions}
                                                            value={employeeOptions.find(option => option.value === formik.values.employeeId)}
                                                            onChange={handleEmployeeChange}
                                                            onBlur={formik.handleBlur}
                                                            placeholder="Select User Name"
                                                        />
                                                        {formik.touched.employeeId && formik.errors.employeeId && (
                                                            <div style={{ color: 'red', marginTop: '5px' }}>
                                                                {formik.errors.employeeId}
                                                            </div>
                                                        )}
                                                    </FormGroup>
                                                </Col>

                                            </Row>

                                            <Row className='my-2'>
                                                {/* From Date Picker */}
                                                <Col md="4">
                                                    <FormGroup>
                                                        <Label for="date">Date</Label>
                                                        <DatePicker
                                                            selected={formik.values.date}
                                                            onChange={(date) => { handleDateChange(date, 'date'); }}
                                                            dateFormat="dd/MM/yyyy"
                                                            className="form-control"
                                                            placeholderText="Select Date"
                                                            popperPlacement="bottom-start"
                                                        />
                                                        {formik.touched.date && formik.errors.date && (
                                                            <div style={{ color: 'red', marginTop: '5px' }}>
                                                                {formik.errors.date}
                                                            </div>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                            </Row>

                                            <Row className="mt-3">
                                                {/* Submit Button */}
                                                <Col md="12">
                                                    <Button color="primary" type="submit" disabled={disabelSaveBtn || !canRead}>
                                                        Submit
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </div>

                                    {
                                        data.length != 0
                                            ?
                                            <div className='mt-3'>
                                                <div className="d-flex align-items-center justify-content-end mb-2">
                                                    <div className="flex-shrink-0">
                                                        <button
                                                            onClick={exportToExcel}  // Trigger the export function
                                                            className="btn btn-primary me-1"
                                                        >
                                                            Export Excel
                                                        </button>
                                                    </div>
                                                </div>
                                                <TableContainer
                                                    columns={columns}
                                                    data={data || []}
                                                    isGlobalFilter={true}
                                                    isPagination={true}
                                                    SearchPlaceholder="Search..."
                                                    isCustomPageSize={true}
                                                    tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                                    theadClass="table-light"
                                                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                                    pagination="pagination"
                                                    getRowProps={row => ({
                                                        className: "",
                                                    })}
                                                    onPageChange={handlePageChange} // Pass page change handler
                                                    onPageSizeChange={handlePageChange} // Pass page size change handler
                                                    pageSize={pageSize}
                                                    setPageSize={setPageSize}
                                                    totalPages={totalPages}
                                                    totalItems={totalItems}
                                                    tableNextPage={nextPage}
                                                    tablePreviousPage={previousPage}
                                                    tableCurrentPage={currentPage}
                                                    customePageSize={customePageSize}

                                                />
                                            </div>
                                            :
                                            ''
                                    }
                                </CardBody>
                            </Card>
                        </Container>
                    </div>

                    {isPopupVisible && (
                        <PopupWindow message={popupMessage} type={popupType} onClose={closePopup} />
                    )}
                </React.Fragment>
            );
        }
    }
}

UsersDailyCallingJourneyReport.propTypes = {
    t: PropTypes.any,
};

export default withTranslation()(UsersDailyCallingJourneyReport);

